/** The connector marks and legend lines the solution pages share. */
export const LOGO = {
  drive: { name: "Google Drive", logo: "/concepts/source-icons/google-drive.png" },
  github: { name: "GitHub", logo: "/concepts/source-icons/github.png" },
  hubspot: { name: "HubSpot", logo: "/concepts/source-icons/hubspot.svg" },
  linear: { name: "Linear", logo: "/concepts/source-icons/linear.png" },
  outlook: { name: "Outlook", logo: "/concepts/source-icons/outlook.svg" },
  sharepoint: { name: "SharePoint", logo: "/concepts/source-icons/sharepoint.svg" },
  sheets: { name: "Google Sheets", logo: "/concepts/source-icons/google-sheets.png" },
  slack: { name: "Slack", logo: "/concepts/source-icons/slack.png" },
  sunsystems: { name: "SunSystems", logo: "/concepts/source-icons/sunsystems.svg" },
  xero: { name: "Xero", logo: "/concepts/source-icons/xero.svg" },
} as const;

export const ASK_LINE = "Ask about the same records in Twin chat or a connected AI tool.";
export const CHECK_LINE = "Check the connections and figures against your source records.";
